//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { PaymentSourceInputItem } from './PaymentSourceInputItem';
import { PaymentProcessorType } from './Enums';

export class StripePaymentSourceInputItem extends PaymentSourceInputItem {
    PaymentMethodID: string | null = null;
    IntentID: string | null = null;
    ReturnUrl: string | null = null;
    override readonly ProcessorType: PaymentProcessorType = PaymentProcessorType.Stripe;

    constructor(initializer?: Partial<Omit<StripePaymentSourceInputItem, "ProcessorType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "StripePaymentSourceInputItem";
}
